import classNames from "components/ui/classNames";
import type { ReactNode } from "react";
import * as React from "react";

interface IMenuProps extends React.DetailedHTMLProps<React.HTMLAttributes<HTMLUListElement>, HTMLUListElement> {
  children: ReactNode;
}

export default function Menu({ children, ...props }: IMenuProps) {
  return (
    <ul
      className={classNames(
        "m-0 grid min-w-[180px] max-w-[280px] list-none gap-y-1 rounded-xl border px-3 py-1.5",
        "border-transparent",
      )}
      {...props}
    >
      {children}
    </ul>
  );
}
